import { createRootRoute, Outlet, useNavigate, useRouterState } from '@tanstack/react-router'
import { AppLayout } from '../app/router/app-layout'
import { CartNotification } from '@/widgets/cart-notification'
import { useSettingsButton, useTelegram } from '@/shared/lib/telegram'
import { useCallback, useEffect, useRef } from 'react'

function RootComponent() {
  const navigate = useNavigate()
  const routerState = useRouterState()
  const currentPath = routerState.location.pathname
  const { webApp } = useTelegram()
  const hasHandledStartParam = useRef(false)
  
  // Обработка start_param (deeplink) при первом запуске
  useEffect(() => {
    if (hasHandledStartParam.current) return
    
    const startParam = webApp?.initDataUnsafe?.start_param
    if (!startParam) return
    
    hasHandledStartParam.current = true
    console.log('[Deeplink] Processing start_param:', startParam)
    
    // Парсим start_param: tea_slug / teaware_slug / product_slug → /product/$productId
    // (миниапп использует один роут /product/$productId, productId принимает slug —
    // useTeaById / useTeawareById сами разруливают по типу)
    if (startParam.startsWith('tea_')) {
      const slug = startParam.replace('tea_', '')
      navigate({ to: '/product/$productId', params: { productId: slug } })
    } else if (startParam.startsWith('teaware_')) {
      const slug = startParam.replace('teaware_', '')
      navigate({ to: '/product/$productId', params: { productId: slug } })
    } else if (startParam.startsWith('product_')) {
      const id = startParam.replace('product_', '')
      navigate({ to: '/product/$productId', params: { productId: id } })
    } else if (startParam.startsWith('order_')) {
      const orderId = startParam.replace('order_', '')
      navigate({ to: '/order/$orderId', params: { orderId } })
    } else if (startParam.startsWith('event_')) {
      const eventId = startParam.replace('event_', '')
      navigate({ to: '/event/$eventId', params: { eventId } })
    } else if (startParam === 'tea-diary' || startParam === 'tea_diary' || startParam === 'diary') {
      navigate({ to: '/tea-diary' })
    } else if (startParam === 'events') {
      navigate({ to: '/events' })
    } else if (startParam === 'cart') {
      navigate({ to: '/cart' })
    } else if (startParam === 'orders') {
      navigate({ to: '/orders' })
    } else if (startParam === 'gift-cards' || startParam === 'gift_cards') {
      navigate({ to: '/gift-cards' })
    } else if (startParam === 'profile') {
      navigate({ to: '/profile' })
    }
  }, [webApp, navigate])
  
  // SettingsButton → Профиль (скрываем на странице профиля)
  const isProfilePage = currentPath === '/profile'
  const handleSettingsClick = useCallback(() => {
    navigate({ to: '/profile' })
  }, [navigate])
  
  useSettingsButton(!isProfilePage, handleSettingsClick)
  
  return (
    <AppLayout>
      <Outlet />
      <CartNotification />
    </AppLayout>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
  // Context будет передаваться через router context
})
